import { useEffect, useState } from "react";

const useNav = () => {
  const [sdkUrl, setSdkUrl] = useState({
    header: "",
    footer: ""
  });

  const loadScript = (url: string, init: () => void) => {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.async = true;

      script.onload = () => {
        console.log("Script loaded successfully:", url);
        init();
        resolve();
      };

      script.onerror = (error) => {
        console.error(`Failed to load script: ${url}`, error);
        reject(new Error(`Failed to load script: ${url}`));
      };

      document.body.appendChild(script);
    });
  };

  const initHeader = async (init: () => void) => {
    if (sdkUrl.header) {
      try {
        await loadScript(sdkUrl.header, init);
      } catch (error) {
        console.error("Failed to initialize header:", error);
      }
    }
  };

  const initFooter = async (init: () => void) => {
    if (sdkUrl.footer) {
      try {
        await loadScript(sdkUrl.footer, init);
      } catch (error) {
        console.error("Failed to initialize footer:", error);
      }
    }
  };

  useEffect(() => {
    if (window.sdkUrl) {
      setSdkUrl(window.sdkUrl);
    }
  }, []);

  return {
    sdkUrl,
    initHeader,
    initFooter
  };
};

export default useNav;
